import React, { memo } from 'react';
import { Box } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

import useStyles from './styles';

const Loading = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box className="appointment-icon">
        <Skeleton variant="circle" width={24} height={24} />
      </Box>
      <Box className="appointment-infos-container">
        <Box className="appointment-date">
          <Skeleton variant="text" width="15%" />
          <Skeleton variant="text" width="30%" />
        </Box>
        <Box className="appointment-professional">
          <Skeleton
            variant="text"
            width="15%"
            className="appointment-professional-label"
          />
          <Skeleton
            variant="text"
            width="50%"
            className="appointment-professional-name"
          />
        </Box>
        <Box className="appointment-status">
          <Skeleton variant="text" width="50%" />
        </Box>
      </Box>
      <Box className="appointment-actions" mr={1}>
        <Skeleton
          variant="circle"
          width={24}
          height={24}
          className="appointment-actions-btn"
        />
      </Box>
    </Box>
  );
};

export default memo(Loading);
